import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
   footer: {
      padding: theme.spacing(1, 2),
      flex: '0 1 32px'
   },
   copyright: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '10px',
      color: '#616161'
   },
   policy: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '9px',
      color: '#6B6C6F',
      mixBlendMode: 'normal',
      opacity: '0.5'
   }
}))

const Footer = () => {
   const classes = useStyles()
   return (
      <footer className={classes.footer}>
         <Grid>
            <Typography className={classes.copyright}>
               {`© Copyright ${moment().format(
                  'YYYY'
               )} Todos los derechos reservados MUTUAL SER EPS`}
            </Typography>
            <Typography className={classes.policy}>
               {
                  'Política de protección de datos personales - Conozca nuestra política para garantizar la seguridad de sus datos personales.'
               }
            </Typography>
         </Grid>
      </footer>
   )
}

export default Footer
